import { Platform } from 'react-native';

export const CLASS_BUILDER_TILE_IMAGE_LOCAL = require('../../assets/ChatGPT Image Jul 20, 2026, 05_12_31 AM.png');

/** Served from Vercel `web-build/` root (`public/class-builder-tile.png` copied at build time). */
export const CLASS_BUILDER_TILE_STATIC_WEB_PATH = '/class-builder-tile.png';

export function getClassBuilderTileImageSource() {
  if (Platform.OS === 'web' && process.env.NODE_ENV === 'production') {
    return { imageUrl: CLASS_BUILDER_TILE_STATIC_WEB_PATH };
  }
  return { imageLocal: CLASS_BUILDER_TILE_IMAGE_LOCAL };
}
